import "react";
import o from "../../../prop-types/index.js";
var e = {
  width: "1px",
  height: "0px",
  padding: 0,
  overflow: "hidden",
  position: "fixed",
  top: "1px",
  left: "1px"
};
process.env.NODE_ENV !== "production" && o.node;
export { e as hiddenGuard };